export const navItems = [
  {
    label: "HOME",
    route: "/",
  },
  {
      label: "ESTRUTURA ORGANIZACIONAL",
      route: "/estrutura-organizacional"
  },
  {
    label: "DIÁRIO OFICIAL",
     route: "/publicacoes/diario-oficial"
  },
  {
    label: "SERVIÇOS",
    route: "/servicos",
  },
  {
    label: "NOTÍCIAS",
    route: "/noticias",
  },
];
